<template>
  <v-dialog v-model="isActive" @keydown.esc="isActive = false" max-width="600px" scrollable>
    <v-card>
      <v-card-title class="title">{{ title }}</v-card-title>

      <v-card-text>
        <v-container grid-list-lg>
          <v-layout wrap row justify-space-between class="subheading">
            <slot/>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="isActive = false" flat color="accent">{{ $t('azioni.annulla') }}</v-btn>
        <v-btn @click="onConfirm" color="accent" v-if="!$store.getters.isAbbonamentoExpired">
          {{ $t('azioni.ripristina') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'

export default {
    name: 'RipristinableDialog',
    mixins: [Toggleable],
    props: {
        title: String
    },
    methods: {
        onConfirm () {
            this.$emit('confirm')
        }
    }
}
</script>
